module.exports = __webpack_public_path__ + "media/components/assets/img/logo/mono/visa-ca76147eaf2d81cfcd040cb1e58b8101.svg";